export default __webpack_public_path__ + "static/media/test-image.c4ea7938.jpg";